module.exports = __webpack_public_path__ + "img/embed-icon.68816c49.svg";